var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[_c('iframe',{ref:"iframeDom",attrs:{"name":"iframeDE","id":"iframeDE","width":"100%","height":"100%","iframeborder":"0","scrolling":"none","src":"https://book.yunzhan365.com/ajcf/ubbg/mobile/index.html"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec140542","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/developmentEmpowerment/index.vue
// module id = null
// module chunks = 